import React from "react";

const ShapePartRight = ({ color = "#f0f0f0" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="321.004"
            height="427.639"
            viewBox="0 0 321.004 427.639"
        >
            <path
                id="Differenzmenge_138"
                data-name="Differenzmenge 138"
                d="M375.51,481.1H364V54.462l289.916,0a30.591,30.591,0,0,1,8.652,1.228,29.222,29.222,0,0,1,7.478,3.407A30.5,30.5,0,0,1,683.958,86.22a29.288,29.288,0,0,1-1.6,8.077,30.658,30.658,0,0,1-4.054,7.76L424.29,456.05A60.023,60.023,0,0,1,375.51,481.1Z"
                transform="translate(-363.5 -53.959)"
                fill={color}
                stroke="rgba(0,0,0,0)"
                strokeMiterlimit="10"
                strokeWidth="1"
            />
        </svg>
    );
};

export default ShapePartRight;
